export default {
  error_handler: {
    connection_failed:
      "I'm having trouble connecting right now. Please check your internet connection.",
    connection_timeout: 'Connection timed out. Please try again.',
    auth_failed:
      'Authentication failed. Please refresh the page and try again.',
    queue_timeout:
      'Connection timeout. Your message could not be sent. Please try again.',
    max_retries:
      'Failed to send message after multiple attempts. Please check your connection and try again.',
    message_send_failed: 'Failed to send message. Please try again.',
    unknown_message_type: 'Received an unexpected message format.',
    general_error: 'An unexpected error occurred. Please try again.',
  },
}
